import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import VueHead from 'vue-head'
import Vuex from 'vuex'
import Buefy from 'buefy'
import api from '@/api'
import store from '@/store'

import VueGtag from "vue-gtag";
import { ObserveVisibility } from 'vue-observe-visibility'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import fontawesome from '@/plugins/fontawesome.js'

import Layout from '@/components/Layout.vue'

import config from '@/config.json'
import i18n from './i18n'

import VueViewer from 'v-viewer'

Vue.use(VueViewer,{
  inline: false,
  navbar: false,
  title: false,
  toolbar: {
    zoomIn: {
      show: true,
      size: "large",
    },
    zoomOut: {
      show: true,
      size: "large",
    },
  },
  tooltip: false,
  zoomRatio: 0.25,
})
import zoom from 'vue-image-zoom';

import 'vue-image-zoom/dist/vue-image-zoom.css';

Vue.use(zoom);

Vue.use(fontawesome)

Vue.use(VueHead, {
  separator: '-',
  complement: config.title
})

Vue.use(Buefy, {
  defaultIconComponent: FontAwesomeIcon,
  defaultIconPack: 'fas',
})



Vue.directive('observe-visibility', ObserveVisibility)

Vue.use(i18n)

Vue.component('Layout', Layout)
Vue.config.productionTip = false

Vue.prototype.api = api




new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

